import { useCallback } from 'react';

import { routes } from 'routes/routes';

export const useGetFinalReferer = () =>
  useCallback(({ referrer, state }: { referrer?: string; state?: { referrer?: string } }) => {
    const finalReferer = state?.referrer ?? referrer ?? '/';

    if (
      [
        routes.login.index,
        routes.signUp,
        '/new-password',
        '/forgot-password',
        routes.onboardingTour.index,
        routes.tokenLogin,
      ].some((path) => finalReferer.startsWith(path))
    ) {
      return '/';
    }

    const url = new URL(finalReferer, window.origin);
    url.searchParams.delete('chr');
    const isAbsolute = finalReferer.startsWith('http');

    return isAbsolute ? url.toString() : `${url.pathname}${url.search}${url.hash}`;
  }, []);
